import React, {Component} from 'react';
import PropTypes from 'prop-types';
// import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import FormGroup from '@material-ui/core/FormGroup';
// import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';

import './Divisions.css';

const styles = theme => ({
  colorSwitchBase: {
    color: theme.palette.primary.main,
    '&$colorChecked': {
      color: theme.palette.primary.main,
      '& + $colorBar': {
        backgroundColor: theme.palette.primary.main,
      },
    },
  },
  colorBar: {
    backgroundColor: theme.palette.primary.main
  },
  colorChecked: {}
})

class Divisions extends Component {

  constructor(props) {
    super(props);

    this.state = {
      currentlySelectedLeaderboard: process.env.REACT_APP_DIVISION_ROOT,
    }

    this.switcher = this.switcher.bind(this);
  }

  switcher() {
    let nowSelected = this.state.currentlySelectedLeaderboard;

    if(nowSelected === process.env.REACT_APP_DIVISION_ROOT) {
      return this.setState({
        currentlySelectedLeaderboard: process.env.REACT_APP_DIVISION_SECONDARY
      }, () => {
        this.props.switchLeaderboards(process.env.REACT_APP_DIVISION_SECONDARY, process.env.REACT_APP_DIVISION_ROOT);
      })
    } else {
      return this.setState({
        currentlySelectedLeaderboard: process.env.REACT_APP_DIVISION_ROOT
      }, () => {
        this.props.switchLeaderboards(process.env.REACT_APP_DIVISION_ROOT, process.env.REACT_APP_DIVISION_SECONDARY);
      })
    }
  }

  componentDidUpdate(prevProps) {
    if(prevProps.divisionId !== this.props.divisionId) {
      this.setState({
        currentlySelectedLeaderboard: this.props.divisionId
      })
    }
  }

  render() {
    return (
    <div>

      {/*Division selector, current place indication*/}
      {this.props.how}
      <div className="mh3 mh4-ns mb3 padding-hack relative">
        <div className={'fixed-title absolute w-100 z-3' + (this.props.fixed ? ' ph4 ph5-ns' : '')}>
          <Grid
            container
            justify="space-between"
            alignItems="center">
            <Grid 
              className="tl"
              item
              xs={6}>
              <h2 className="standings mt2 mb1 f6 f4-m f4-l">{this.props.activeIdx < 2 || this.props.howManyToShow > 1 ?
                'Overall Standings  '
              : 'Event ' + (this.props.activeIdx - 1) + '  '}</h2>
              
              <p className="standings sort-order f7 f6-ns mv1 t-green"
              >Sort: {this.props.eventId < 1 ?
                  'Overall'
                : 'Event ' + (this.props.eventConfig.event_ids ? this.props.eventConfig.event_ids.indexOf(this.props.eventId) + 1 : '')} <i alt="arrow-direction" className={'ml-2 fas ' + (this.props.reverse ? ' fa-sort-amount-down' : 'fa-sort-amount-up')} ></i>
              </p>
            </Grid>
            <Grid 
              item
              xs={6}
              className="tr">
              <FormGroup 
                justify="end"
                row
                className="items-center justify-end">
                <Grid
                  onClick={this.switcher.bind(this)} 
                  item>
                  Male
                </Grid>
                <Grid 
                  item
                  onClick={this.switcher.bind(this)}>
                  <Switch
                    classes={{
                      switchBase: this.props.classes.colorSwitchBase,
                      checked: this.props.classes.colorChecked,
                      bar: this.props.classes.colorBar
                    }}
                    checked={this.props.divisionId === process.env.REACT_APP_DIVISION_SECONDARY}
                    color="primary"
                  />
                </Grid>
                <Grid 
                  onClick={this.switcher.bind(this)}
                  item>
                  Female
                </Grid>
              </FormGroup>
            </Grid>
          </Grid>
        </div>
      </div>
    </div>
    )
  }
}

Divisions.propTypes = {
  switchLeaderboards: PropTypes.func.isRequired,
  divisionId: PropTypes.string.isRequired,
  reverse: PropTypes.bool.isRequired,
  eventId: PropTypes.number.isRequired,
  fixed: PropTypes.bool.isRequired,
  activeIdx: PropTypes.number.isRequired,
  eventConfig: PropTypes.object.isRequired,
  howManyToShow: PropTypes.number.isRequired
}

export default withStyles(styles)(Divisions);